/**
 * Shortened ID that copies the full value on click. Safe inside a
 * clickable table row: copying never also triggers the row.
 */
import { Copy } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";

async function copy(id: string) {
  try {
    await navigator.clipboard.writeText(id);
    toast.success("ID copied");
  } catch {
    toast.error("Couldn't copy the ID");
  }
}

export function CopyId({ id, full, className }: { id: string; full?: boolean; className?: string }) {
  return (
    <button
      type="button"
      title={`Copy ${id}`}
      aria-label={`Copy ID ${id}`}
      onClick={(e) => {
        e.stopPropagation();
        void copy(id);
      }}
      onKeyDown={(e) => e.stopPropagation()}
      className={cn(
        "inline-flex items-center gap-1.5 rounded font-mono text-xs text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      {full || id.length <= 14 ? id : `${id.slice(0, 14)}…`}
      <Copy
        className={cn("h-3 w-3 transition-opacity", !full && "opacity-0 group-hover:opacity-100")}
        aria-hidden
      />
    </button>
  );
}
